module.exports = __webpack_public_path__ + "static/notice-punctuation-do-2fdb20fbaa7d280fd07597878f2c143d.png";